export default {
    saveNewUser(state, studentPayload) {
        state.currentStudentCreated = studentPayload;
    },
    setStudents(state, payloadStudents) {
        state.students = payloadStudents
    },
    setFetchTimestamp(state) {
        state.lastFetch = new Date().getTime();
    },
    clearData(state) {
        state.students = [];
        state.lastFetch = null;
    },
    setStudentToEdit(state, payloadStudent) {
        state.editStuentInfo = payloadStudent
    },
    updateStudent(state, payloadStudent) {
        state.editStuentInfo = payloadStudent
    },
    updateListUsers(state, payload) {
        state.students = state.students.map( student => {
            if (student._id == payload._id) {
                student = {...student, ...payload}
            }
            return student
        });
    }
}